import React from 'react'

const About = () => {
  return (<div className='About' >
    <header>
      <h5>Our Mission</h5>
      <hr />
        <h4>To Empower you with Real Time data <br />
        of top 100 Crypto Currency and Exchanges</h4>
        <hr/>
        <a href='https://github.com/vipulagr890'>Github  </a>  
        <a href='https://www.linkedin.com/in/vipul-agrawal-619099127/'>  Li</a>
        </header>
    </div>
  )
}

export default About